<template>
  <div>
    <p class="date-publication">
      {{
        question.created_at
          .substring(0, 10)
          .split("-")
          .reverse()
          .join("/") +
          " - " +
          question.created_at.substring(10, 16)
      }}
    </p>
    <p class="date-publication">ref.{{ question.id }}</p>
    <p v-html="affiche_question(question.question)"></p>
    <p
      class="next-link"
      v-on:click="toggleText = !toggleText"
      v-if="question.question.length > 200"
    >
      {{ toggleText ? "Reduire" : "Afficher la suite" }}
    </p>
    <span v-if="question.media">
      <span v-if="getExtension(question.media, 'image')">
        <img :src="url_media + question.media" class="img_jointe" />
      </span>
      <span v-if="getExtension(question.media, 'video')">
        <video
          controls
          :src="url_media + question.media"
          class="img_jointe"
        ></video>
      </span>
    </span>
    <div v-if="question.response" class="response_container">
      <p class="response_title">Réponse :</p>
      <p v-if="question.response.response.length > 255">
        {{
          toggleResponseText
            ? question.response.response
            : question.response.response.substring(0, 255) + "..."
        }}
      </p>
      <p v-else>
        {{ question.response.response }}
      </p>
      <p
        class="next-link"
        v-on:click="toggleResponseText = !toggleResponseText"
        v-if="question.response.response.length > 255"
      >
        {{ toggleResponseText ? "Reduire" : "Afficher la suite" }}
      </p>
      <span v-on:click="openImage" v-if="question.response.media">
        <span v-if="getExtension(question.response.media, 'image')">
          <img :src="url_media + question.response.media" class="img_jointe" />
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BlocQuestion",
  data() {
    return {
      toggleText: false,
      url_media: process.env.URL_MEDIA,
      toggleResponseText: false
    };
  },
  props: {
    question: {
      required: true
    }
  },
  methods: {
    affiche_question(laQuestion) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      if (laQuestion) {
        laQuestion = laQuestion.replace(urlRegex, function(url, b, c) {
          var url2 = c == "www." ? "http://" + url : url;
          return (
            '<a class="url_pinned" href="' +
            url2 +
            '" target="_blank">' +
            url +
            "</a>"
          );
        });
      }
      if (this.toggleText) {
        return laQuestion;
      } else {
        return laQuestion.substring(0, 200);
      }
    },
    getExtension(chemin, type_test) {
      var extensionsIMG = new Array("png", "gif", "jpg", "jpeg");
      var extensionsVIDEO = new Array("mp4");
      var regex = /[^.]*$/i;
      var resultats = chemin.match(regex);
      if (type_test == "video" && extensionsVIDEO.indexOf(resultats[0]) != -1) {
        return 1;
      }
      if (type_test == "image" && extensionsIMG.indexOf(resultats[0]) != -1) {
        return 1;
      }

      return 0;
    },
    openImage() {
      window.open(this.url_media + this.question.response.media);
    }
  }
};
</script>

<style>
.pageloader {
  background: #424a60;
}
.header {
  background: #424a60;
  height: 60px;
  position: relative;
}

.header h1 img {
  height: 50px;
  margin: 5px;
  vertical-align: middle;
}

.question-mark-infos {
  border: 1px solid #dddbdc;
  background: #fff;
  font-weight: bold;
  padding-bottom: 5px;
  border-radius: 0 0 4px 4px;
}
.text-mark-info {
  font-weight: normal;
  font-size: 14px;
}

.pinnedQuestion {
  margin: 10px;
  padding: 30px;
  min-width: 50px;
  min-height: 50px;
  width: 98%;
  background: #dddbdc !important;
  font-size: 25px;
  -moz-box-shadow: 0px 2px 8px 0px #656565;
  -webkit-box-shadow: 0px 2px 8px 0px #656565;
  -o-box-shadow: 0px 2px 8px 0px #656565;
  box-shadow: 0px 2px 8px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=8);
  opacity: 0.95;
}

.list-complete {
  margin-top: 20px 0px;
}

.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin: 10px;
  padding: 20px;
  min-width: 50px;
  min-height: 50px;
  -moz-box-shadow: 0px 2px 8px 0px #656565;
  -webkit-box-shadow: 0px 2px 8px 0px #656565;
  -o-box-shadow: 0px 2px 8px 0px #656565;
  box-shadow: 0px 2px 8px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=8);
  background: white;
  opacity: 0.95;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}

.img_jointe {
  margin: 5px 5px 5px 0;
  max-width: 230px;
}
.date-publication {
  font-size: 10px;
  font-style: italic;
  color: #8a898e;
}
.next-link {
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  font-style: italic;
  display: flex;
  justify-content: flex-end;
}
.response_container {
  font-size: 12px;
  background-color: #bcbcbc;
  border-radius: 5px;
  padding: 10px;
  margin-top: 22px;
}
.response_title {
  font-size: 10px;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/animerPage/components/BlocQuestion.vue